import { render, staticRenderFns } from "./ShoulderRaising.vue?vue&type=template&id=1541031c"
import script from "./ShoulderRaising.vue?vue&type=script&lang=js"
export * from "./ShoulderRaising.vue?vue&type=script&lang=js"
import style0 from "./ShoulderRaising.vue?vue&type=style&index=0&id=1541031c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports